import { useCallback, useEffect, useState } from 'react';

export const RESEND_COOLDOWN_MS = 30000;

function useResendCooldown({ startOnMount = false } = {}) {
  const [endsAt, setEndsAt] = useState<number | null>(() =>
    startOnMount ? Date.now() + RESEND_COOLDOWN_MS : null
  );
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (endsAt === null) {
      return;
    }

    function tick() {
      const time = Date.now();
      setNow(time);
      if (time >= endsAt!) {
        setEndsAt(null);
      }
    }

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [endsAt]);

  const startCooldown = useCallback(() => {
    const time = Date.now();
    setNow(time);
    setEndsAt(time + RESEND_COOLDOWN_MS);
  }, []);

  const secondsLeft =
    endsAt === null ? 0 : Math.max(0, Math.ceil((endsAt - now) / 1000));

  return { canResend: secondsLeft === 0, secondsLeft, startCooldown };
}

export default useResendCooldown;
